<template>
  <BaseSection
    class="md:flex max-w-2xl md:mx-auto items-center
    justify-between md:px-0 md:border-t border-border-color md:pt-4"
  >
    <div class="md:flex items-center border-t border-border-color md:border-none pt-4 md:pt-0">
      <Logo
        fill="#C4C4C4"
        class="mr-8 mb-4 md:mb-0 opacity-60"
      />
      <a
        class="text-grey mr-5 font-13 block mb-2 md:mb-0"
        href="https://www.kerala.vc"
        target="_blank"
      >
        Kerala website
      </a>
      <a
        class="text-grey font-13 block mb-8 md:mb-0"
        href="https://www.first20.club"
        target="_blank"
      >
        First20, the Kerala hiring network
      </a>
    </div>
    <div class="flex items-center pb-4">
      <a
        class="text-grey mr-5 font-13"
        href="https://www.notion.so/keralaventures/Comment-faire-une-r-clamation-d90b4001d12e4caba87859cd89c59af4"
        target="_blank"
      >
        Réclamations
      </a>
      <router-link
        class="text-grey font-13"
        to="/legal-notice"
      >
        Mentions légales
      </router-link>
    </div>
  </BaseSection>
</template>

<script>
import Logo from './icons/Logo.vue';
import BaseSection from './BaseSection.vue';

export default {
  name: 'TheFooter',
  components: {
    Logo,
    BaseSection,
  },
};
</script>

<style lang="scss" scoped>
.font-13 {
  font-size: 13px;
}
</style>
